﻿import { AntdFormInput, AntdFormPassword } from '@/common/components/AntdForm/AntdFormInput.tsx'
import { AntdFormDatePicker, AntdFormDayjsPicker } from '@/common/components/AntdForm/AntdFormDatePicker.tsx'
import { AntdFormItem } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { AntdFormTextArea } from '@/common/components/AntdForm/AntdFormTextArea.tsx'
import { AntdFormCurrency, AntdFormMonth, AntdFormSelect } from '@/common/components/AntdForm/AntdFormSelect.tsx'
import { AntdFormNumberInput } from '@/common/components/AntdForm/AntdFormNumberInput.tsx'
import { AntdFormTimeDurationInput } from '@/common/components/AntdForm/AntdFormTimeDurationInput.tsx'
import { AntdFormBoolean } from '@/common/components/AntdForm/AntdFormBoolean.tsx'
import {
  AntdFormEmployeeDocumentUpload,
  AntdFormSingleEmployeeDocumentUpload,
} from '@/common/components/AntdForm/AntdFormEmployeeDocumentUpload.tsx'
import { AntdFormSwitch } from '@/common/components/AntdForm/AntdFormSwitch.tsx'
import { AntdFormMoneyInput } from '@/common/components/AntdForm/AntdFormMoneyInput.tsx'
import { AntdFormExcelInput } from '@/common/components/AntdForm/AntdFormExcelInput.tsx'
import { AntdFormComboBox } from '@/common/components/AntdForm/AntdFormComboBox.tsx'
import { AntdFormYearPicker } from '@/common/components/AntdForm/AntdFormYearPicker.tsx'
import {
  AntdFormAccessibleEmployeeDataSection,
  AntdFormManagedEmploymentEntities,
  AntdFormCheckbox,
  AntdFormManagedCountry,
} from '@/common/components/AntdForm/AntdFormCheckbox.tsx'
import { AntdFormEmployeeSearch } from '@/common/components/AntdForm/AntdFormEmployeeSearch.tsx'
import { AntdFormStarRate } from '@/common/components/AntdForm/AntdFormStarRate.tsx'
import {
  AntdFormSection,
  AntdFormSectionWrapper,
  AntdFormWrapper,
} from '@/common/components/AntdForm/AntdFormWrapper.tsx'
import { AntdFormCopyButton } from '@/common/components/AntdForm/AntdFormCopyButton.tsx'
import { AntdFormRadio } from '@/common/components/AntdForm/AntdFormRadio.tsx'
import { AntdFormDateRangePicker } from '@/common/components/AntdForm/AntdFormDateRangePicker.tsx'
import { AntdFormDetailedFileList } from '@/common/components/AntdForm/AntdFormDetailedFileList.tsx'
import { AntdFormList } from '@/common/components/AntdForm/AntdFormList.tsx'

export const AntdForm = {
  FormWrapper: AntdFormWrapper,
  SectionWrapper: AntdFormSectionWrapper,
  Section: AntdFormSection,
  Item: AntdFormItem,
  List: AntdFormList,
  Input: AntdFormInput,
  Password: AntdFormPassword,
  TextArea: AntdFormTextArea,
  NumberInput: AntdFormNumberInput,
  MoneyInput: AntdFormMoneyInput,
  Select: AntdFormSelect,
  Currency: AntdFormCurrency,
  Year: AntdFormYearPicker,
  Month: AntdFormMonth,
  Checkbox: AntdFormCheckbox,
  Radio: AntdFormRadio,
  ManagedCountry: AntdFormManagedCountry,
  ManagedEmploymentEntities: AntdFormManagedEmploymentEntities,
  AccessibleSection: AntdFormAccessibleEmployeeDataSection,
  ComboBox: AntdFormComboBox,
  Boolean: AntdFormBoolean,
  Switch: AntdFormSwitch,
  TimeDuration: AntdFormTimeDurationInput,
  DatePicker: AntdFormDatePicker,
  DateRangePicker: AntdFormDateRangePicker,
  DayjsPicker: AntdFormDayjsPicker,
  EmployeeDocumentUpload: AntdFormEmployeeDocumentUpload,
  SingleEmployeeDocumentUpload: AntdFormSingleEmployeeDocumentUpload,
  DetailedFileList: AntdFormDetailedFileList,
  ExcelInput: AntdFormExcelInput,
  EmployeeSearch: AntdFormEmployeeSearch,
  StarRate: AntdFormStarRate,
  CopyButton: AntdFormCopyButton,
}